import { render, staticRenderFns } from "./AlterarDadosTecnico.vue?vue&type=template&id=16f9f32a"
import script from "./AlterarDadosTecnico.vue?vue&type=script&lang=js"
export * from "./AlterarDadosTecnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports